import { useMemo, useState } from "react";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import PermitRouteMap from "../../components/Permits/PermitRouteMap/PermitRouteMap";

const stateOptions = [
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "FL",
  "GA",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NM",
  "NV",
  "OH",
  "OK",
  "OR",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "WA",
  "WI",
  "WY",
];

const sampleRoute = `Order,Instruction,Latitude,Longitude
1,"Border Start: Indiana - I-94",41.568600,-87.524500
2,"Go on I-80 / I-94",41.568800,-87.542000
3,"Fork left toward US-6 / I-294 / I-80 W",41.568900,-87.552500
4,"Border End: Wisconsin - I-94",42.493700,-87.950100`;

const OperationsPermitRoutePage = () => {
  const [routeInput, setRouteInput] = useState(sampleRoute);
  const [defaultStateInput, setDefaultStateInput] = useState("IL");
  const [submittedRoute, setSubmittedRoute] = useState(sampleRoute);
  const [submittedDefaultState, setSubmittedDefaultState] = useState("IL");

  const hasRoute = useMemo(
    () => submittedRoute.trim().length > 0,
    [submittedRoute],
  );

  const handleGenerate = () => {
    setSubmittedRoute(routeInput.trim());
    setSubmittedDefaultState(defaultStateInput);
  };

  return (
    <Stack spacing={3} sx={{ p: { xs: 2, md: 3 } }}>
      <Box>
        <Typography variant="h4" gutterBottom>
          Permit Route Map
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Paste permit route instructions to generate a route map and review
          border crossings and mileage.
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Stack spacing={2}>
            <TextField
              label="Permit route instructions"
              multiline
              minRows={4}
              value={routeInput}
              onChange={(event) => setRouteInput(event.target.value)}
              placeholder="Paste the route steps from your permit here"
              fullWidth
            />
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={2}
              alignItems={{ xs: "stretch", sm: "flex-start" }}
            >
              <TextField
                select
                label="Default state"
                value={defaultStateInput}
                onChange={(event) => setDefaultStateInput(event.target.value)}
                sx={{ minWidth: { xs: "100%", sm: 180 } }}
              >
                {stateOptions.map((state) => (
                  <MenuItem key={state} value={state}>
                    {state}
                  </MenuItem>
                ))}
              </TextField>
              <Button
                variant="contained"
                onClick={handleGenerate}
                sx={{ minWidth: 180 }}
              >
                Generate map
              </Button>
            </Stack>
          </Stack>
        </CardContent>
      </Card>

      {!hasRoute && (
        <Alert severity="info">
          Enter permit route instructions to generate the map.
        </Alert>
      )}

      <PermitRouteMap
        routeText={submittedRoute}
        defaultState={submittedDefaultState}
      />
    </Stack>
  );
};

export default OperationsPermitRoutePage;
